var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "card cursor-pointer p-2 pl-3",
      class: [
        _vm.selected ? "border-primary" : "border-light",
        _vm.hovered ? "font-weight-bold bg-primary" : "bg-light"
      ],
      on: {
        click: function($event) {
          _vm.selected = !_vm.selected
        },
        mouseenter: function($event) {
          _vm.hovered = true
        },
        mouseleave: function($event) {
          _vm.hovered = false
        }
      }
    },
    [
      _c("span", { class: { "font-weight-bold": _vm.selected } }, [
        _vm._v(
          "\n        " + _vm._s(_vm.series.title[_vm.$i18n.locale]) + "\n    "
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }